export const joinParts = (...parts: Array<string | undefined>): string => `/${parts.filter(Boolean).join('/')}`
